import { Container } from '../_app.style'
import { styled } from '../stitches.config'
import { TIMELINE_COL_WIDTH } from './constants.style'
import { BottomOfMainStrip, BottomOfMainStripHelper, MainBackgroundArea, ModulesArea, SwitcherArea, TopBarArea, TopOfModuleStrip, WeeksArea } from './gridAreas'

export const DesktopTimelineContainer = styled(Container, {
  $$columnWidth: TIMELINE_COL_WIDTH,
  $$rowHeight: '7rem',
  $$navHeight: '4rem',
  display: 'grid',
  gridTemplateAreas: `
  'switcher topbar'
  'switcher weeks'
  'modules background'
  `,

  gridTemplateRows: 'auto',

  gridTemplateColumns: '$$columnWidth 1fr',
  // gridGap: '1rem',

  rowGap: 0,           // This REMOVES the vertical gap
  columnGap: '1rem',   // This KEEPS the horizontal gap

  padding: '0 1rem 0 0',
  paddingBottom: '2.5rem',
  maxWidth: '100%',
  background: '#f0f2f5',

  '@media (max-width: 900px)': {
    gridTemplateColumns: '3.2rem 1fr',
    gridTemplateAreas:  
      `
      'switcher topbar'
      '. weeks'
      'modules background'
      `
    ,

    '&.popup-open': {
      gridTemplateAreas: `
        'switcher topbar'
        '. weeks'
        'modules background'
        'popup popup'
      `,

      gridTemplateRows: `
        auto        
        auto       
        auto   
        calc(45dvh / var(--scale, 1))              
      `,
    
      '&.keyboard-open': {

        [`& ${WeeksArea}, & ${TopBarArea}, & ${SwitcherArea}, ${TopOfModuleStrip}, & ${ModulesArea}, & ${MainBackgroundArea}, & .gap-strip`]: {
          display: 'none !important',
       },
       
        gridTemplateAreas: `
        'popup popup'
      `,

       paddingTop: '1rem',
       paddingRight: 0,

       gridTemplateRows: `
        1fr
       `
      }
    
    }

  },


  position: 'relative', 

  height: 'fit-content', // or manually calculated height (e.g. 24 * 64px)
  minHeight: '100%',     // Ensures it's at least as tall as the screen
  
  width: '100%',
  
  variants: {
    shape: {
      rounded: {
        borderRadius: '16px', // Or your preferred value
        overflow: 'hidden',   // This is crucial for making it work
      },
    },
  },
})